/*export default function DefaultLayout({ children }) {
    return <>{children}</>;
}*/
import { useState, useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import conalepBlanco from "./../../assets/images/escudos/conalepBlanco.png";
import colibriHorizontal from "./../../assets/images/escudos/Colibri_Horizontal_FondoOscuro.png";
import escudoEdomex from "./../../assets/images/escudos/ESCUDO EDOMEX_Horizontal_FondoOscuro.png";

import { Layout, Menu, Grid, Image, Flex, Row, Card, Avatar, Tooltip, Col } from "antd";

import * as ALLICONS from '@ant-design/icons';

const KEY_MENU_CLOSE_MENU = "logout";

const close_session = [{
    key: KEY_MENU_CLOSE_MENU,
    label: "Cerrar Sesión",
    icon: "PoweroffOutlined",
    path: "/",
}]



const { Header, Content, Footer, Sider } = Layout;

export default function DefaultLayout({ children }) {
    const { useBreakpoint } = Grid;

    const screens = useBreakpoint();

    useEffect(() => {

    }, [screens]);

    return (
        <Layout style={{ minHeight: "100vh" }}  >
            <Header>
                <Flex justify="center">
                    <Image
                        preview={false}
                        src={escudoEdomex}
                        alt="logotipo Conalep"
                        width={"90px"}
                        style={{ minWidth: "90px" }}
                    />
                    <Image
                        preview={false}
                        src={colibriHorizontal}
                        alt="logotipo Conalep"
                        width={"90px"}
                        style={{ minWidth: "90px" }}
                    />
                    <Image
                        preview={false}
                        src={conalepBlanco}
                        alt="logotipo Conalep"
                        width={"100px"}
                        style={{ minWidth: "90px" }}
                    />
                </Flex>
            </Header>
            <Layout>
                <Layout>
                    <Content style={{ backgroundColor: "#fff" }}>
                        <div
                            style={{
                                backgroundColor: "white",
                                height: "100%",
                                padding: "24px", // opcional
                                minHeight: "calc(100vh - 134px)" // para ocupar toda la pantalla menos el header y footer
                            }}>
                            {children}
                        </div>
                    </Content>
                    {screens.sm &&
                        <Footer style={{ textAlign: "center" }}>
                            <b> Copyright  ©{new Date().getFullYear()} CONALEP Estado de México. </b> Todos los derechos son reservados.
                        </Footer>}
                </Layout>
            </Layout>
        </Layout>
    );
}; 